export default "__VITE_ASSET__2KCLY7_k__"